import { ExecutorCheckListType } from './types';

export enum RequestHandler {
  DRAFT = 'DRAFT',
  MODERATION = 'MODERATION',
  SECONDARY = 'SECONDARY',
}

export const mapExecutorChecklistField = {
  FullName: 'FullName',
  PhoneNumber: 'PhoneNumber',
  Email: 'Email',
  BirthDate: 'BirthDate',
  Inn: 'Inn',
  Snils: 'Snils',
  Citizenship: 'Citizenship',
  ServiceCities: 'ServiceCities',
  Offer: 'Offer',
  Bik: 'Bik',
  BankSettlement: 'BankSettlement',
  Passport: 'Passport',
  SelfieWithPassport: 'SelfieWithPassport',
  SelfemployedCertificate: 'SelfemployedCertificate',
  IndividualCertificate: 'IndividualCertificate',
  PrimaryEducation: 'PrimaryEducation',
  SecondaryEducation: 'SecondaryEducation',
  WorkExperience: 'WorkExperience',
  CertificateElectricalSafety: 'CertificateElectricalSafety',
  CertificateWorkHeight: 'CertificateWorkHeight',
} as const;
